import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { isCellPhone, isNotValidName } from '../../utils/validator'
import { ConvertToEnglish, pexios, toast } from '../../utils/functions'
import { useDispatch, useSelector } from 'react-redux'
import { setAccidentInfo } from '../../redux/actions'
import { history } from '../../utils/variables'
import Modal from '../../components/master/Modal'
import AddLosses from '../../assets/images/header-icon/add-losses.png'
import LossesList from '../../assets/images/header-icon/losses-list.png'

const LossesInfo = () => {
    const {t} = useTranslation()
    const {user,accidentInfo} = useSelector(store=>store)
    const {id} = useSelector(store=>store.routerData)
    const dispatch = useDispatch();
    const [loader,setLoader] = useState(false);
    const [step ,setStep] = useState('add')
    const [btnLoading,setBtnLoading] = useState(true)
    const [allLosses,setAllLosses] = useState([])
    const [lossesData,setLossesData] = useState({
        fname:'',
        lname:'',
        mobile:''
    })
    const [validationError,setValidationError] = useState({
        fname:'',
        lname: ''
    })
    const [uniqeItems,setUniqeItems] = useState([])
    useEffect(()=>{
        setBtnLoading(!(lossesData.fname && lossesData.lname && lossesData.mobile && !validationError.fname && !validationError.lname))
    },[lossesData,validationError])
    useEffect(()=>{
        setLoader(true)
        pexios(`api/get_accident_losses/${id}`)
        .then((res)=>{
            const losses = res.data.losses
            const culprit = res.data.culprit
            let lossesItems = []
            if(losses.length > 0) {
                setAllLosses(losses)
                lossesItems = losses.map((l)=>(
                    {'mobile':l.mobile,
                    'chassis_number': l.car?.chassis_number,
                    'plate_center':l.car?.plate_center,
                    'plate_iran':l.car?.plate_iran,
                    'plate_left':l.car?.plate_left,
                    'plate_right':l.car?.plate_right,
                    'plate_type':l.car?.plate_type,
                    }
                ))
                setStep('list')
            }
            setUniqeItems([
                ...lossesItems,
                {'mobile':culprit.mobile,
                'chassis_number': culprit.car?.chassis_number,
                'plate_center':culprit.car?.plate_center,
                'plate_iran':culprit.car?.plate_iran,
                'plate_left':culprit.car?.plate_left,
                'plate_right':culprit.car?.plate_right,
                'plate_type':culprit.car?.plate_type,
                }
            ])
            setLoader(false)
        })
    },[id])
    function checkRepeated () {
        const foundItem = uniqeItems.filter(item=>ConvertToEnglish(item.mobile) === ConvertToEnglish(lossesData.mobile))
        return foundItem.length
    }
    function changeText(value,name) {
        if(name !== 'mobile'){
            if(isNotValidName(value)){
                setValidationError(prevState=>({
                    ...prevState,
                    [name] : `${name === 'fname' ? 'نام' :'نام خانوادگی'} را به صورت فارسی و بدون عدد وارد نمایید`
                }))
            }else {
                setValidationError(prevState=>({
                    ...prevState,
                    [name] : ''
                }))
            }
        }
        setLossesData(prevState => ({
            ...prevState,
            [name]: value,
        }));
    }
    function submitLossesInfo(){
        if(lossesData.fname.length < 3|| lossesData.lname.length < 3){
            toast('نام یا نام خانوادگی نامعتبر است', 'error');
            return;
        }
        const isCellphoneValid= isCellPhone(ConvertToEnglish(lossesData.mobile));
        if (!isCellphoneValid) {
            toast(t('Mobile number is not valid'), 'error');
            return;
        }
        if(checkRepeated()) {
            toast('شماره موبایل زیان دیده تکراری میباشد', 'error');
            return;
        }
        dispatch(setAccidentInfo({user_type:'losses',insurance_type : 'third',lossesData:lossesData,has_coroukie:accidentInfo?.has_coroukie}))
        history.push('/plans',uniqeItems);
    }
  return (
    <div className='content m20'>
        {loader ?
        <Modal visible={loader}>
            <div className='loader-modal'>
                <i className='fas fa-spinner fa-spin'/>
            </div>
        </Modal>
        :
        <>
        {step === 'list' &&
        <div>
            <div className='title-image'>
                <img src={LossesList} alt="icon"/>
            </div>
            <p className='guide-text mx10 mt10'>
                  {user.full_name} عزیز  
            </p>
            <p className='guide-text mx10 mt10'>
                <span style={{fontWeight:500}}>{allLosses.reduce((prev,l)=>(`${prev} ${l.full_name} ،`),'')} </span>
            به عنوان زیاندیده حادثه ثبت شده {allLosses.length === 1 ? 'است' :'اند'}، درصورتی که حادثه زیاندیده دیگری نیز دارد با زدن دکمه <span style={{color: '#048765',fontWeight:500}}>افزودن زیاندیده جدید</span> , مشخصات مربوط به ایشان را در پرونده ثبت نمایید.
            </p>
            <p className='guide-text mx10 mt10'>
            در صورتی که اطلاعات تمامی زیاندیدگان حادثه را ثبت نموده اید با زدن دکمه <span style={{color: '#F6945A',fontWeight:500}}>مرحله بعد</span> فرآیند ثبت خسارت خود را ادامه دهید.  
            </p>

            <div className='d-flex mt60'>
                <button 
                    className='btn btn-circle btn-block btn-white-purple w-50 mx5'
                    onClick={()=>history.push('/complete')}
                    >مرحله بعد 
                </button>
                <button 
                    className='btn btn-circle btn-block btn-green w-50 mx5' 
                    onClick={()=>setStep('add')}>افزودن زیان دیده
                </button>
            </div>

        </div>
        }
        {step === 'add' &&
            <div className='text-right'>
                <div className='title-image'>
                    <img src={AddLosses} alt="icon"/>
                </div>
                <p className='guide-text my20'>
                لطفا جهت افزودن <span style={{fontWeight : 'bold'}}>زیاندیده</span> به پرونده، نام و نام خانوادگی و شماره تلفن همراه زیاندیده حادثه را وارد نمایید.
                </p>

                    {/* <Input
                        value={lossesData.fname}
                        label='نام'
                        placeholder={`${t('First name')} ${t('Losses')}`}
                        onChange={value => changeText(value, 'fname')}
                        name='fname'
                    />
                    <Input
                        value={lossesData.lname}
                        label='نام خانوادگی'
                        placeholder={`${t('Last name')} ${t('Losses')}`}
                        onChange={value => changeText(value, 'lname')}
                        name='lname'
                    />
                    <Input
                        value={lossesData.mobile}
                        type='number'
                        label='شماره همراه'
                        placeholder={`شماره همراه ${t('Losses')}`}
                        onChange={value => changeText(value, 'mobile')}
                    /> */}
                    <div className='input-parent withIcon rtl mt10'>
                        <input
                            value={lossesData.fname}
                            type='text'
                            placeholder={`${t('First name')} ${t('Losses')}`}
                            onChange={e => changeText(e.target.value, 'fname')}
                        />
                        <i className='fas fa-user'/>
                    </div>
                    {validationError.fname && <small className='feild-validation'>{validationError.fname}</small>}

                    <div className='input-parent withIcon rtl mt10'>
                        <input
                            value={lossesData.lname}
                            type='text'
                            placeholder={`${t('Last name')} ${t('Losses')}`}
                            onChange={e => changeText(e.target.value, 'lname')}
                        />
                        <i className='fas fa-user'/>
                    </div>
                    {validationError.lname && <small className='feild-validation'>{validationError.lname}</small>}

                    <div className='input-parent withIcon rtl mt10'>
                        <input
                            value={lossesData.mobile}
                            type='number'
                            placeholder={`شماره همراه ${t('Losses')}`}
                            onChange={e => changeText(e.target.value, 'mobile')}
                        />
                        <i className='fas fa-mobile'/>
                    </div>
                <div className='d-flex align-items-center ml20 mr20 mt30'>
                    <button 
                        className={`btn btn-circle btn-block ${btnLoading ? 'btn-disable' : 'btn-white-purple'}`} 
                        onClick={submitLossesInfo}
                        disabled={btnLoading}
                        >ثبت 
                    </button>
                </div>
                </div>
        }
        </>
        }
    </div>
  )
}

export default LossesInfo